import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  // set the currenr year
  year: number = new Date().getFullYear();

  constructor(private router: Router) { }

  get showFooter(): boolean {
    return !this.router.url.startsWith('/file-manager-page');
  }

  ngOnInit(): void {
  }

}
